import { useCallback } from "react"
import { useParams } from "react-router-dom"
import { Box, useTheme } from "@mui/material"

import { IContentWithAsideProps } from "layouts/kiosk-h/ContentWithAside"
import { AppNavigation as DefaultAppNavigation } from "containers/kiosk-h"

import { useTranslation } from "providers/i18n"
import { useAppUI } from "providers/ui"
import { usePageSideBarLayout } from "providers/ui/hooks"

import { usePromotionDetail } from "hooks/promotion/usePromotionDetail"
import { useMobileUrl } from "hooks/useMobileUrl"

import { PageCard } from "components/card"
import { SidebarMenu } from "components/navigation/SidebarMenu"
import { DetailPage } from "components/domains/features/DetailPage"

interface IPromotionDetailKioskHPageProps {
  Layout?: React.FC<IContentWithAsideProps>
  AppNavigation?: React.ComponentType
}

export const PromotionDetailKioskHPage = ({
  Layout = Box,
  AppNavigation = DefaultAppNavigation,
}: IPromotionDetailKioskHPageProps) => {
  const { t } = useTranslation()

  const params = useParams()
  const { promotionId } = params

  const { promotion, navigateToLocation } = usePromotionDetail(promotionId)

  const { goBack } = useAppUI()

  const { mobileUrl } = useMobileUrl()

  usePageSideBarLayout({
    sidebar: {
      open: false,
    },
  })

  const theme = useTheme()

  const styleOverrides =
    theme.components[`PromotionDetailPage`]?.styleOverrides || {}
  const { root } = styleOverrides

  const handleClickBack = useCallback(() => {
    goBack()
  }, [goBack])

  if (!promotion) return null

  return (
    <>
      <Layout
        aside={
          <PageCard>
            <SidebarMenu AppNavigation={AppNavigation} />
          </PageCard>
        }
      >
        {promotion && (
          <DetailPage
            sx={root}
            item={promotion}
            headerDetail={t("Promotion Detail")}
            mobileUrl={mobileUrl}
            onBack={handleClickBack}
            onViewLocation={navigateToLocation}
          />
        )}
      </Layout>
    </>
  )
}
